module.exports = __webpack_public_path__ + "img/7.634a6727.jpg";